import { lowerCase, upperFirst } from 'lodash'
import React from 'react'

interface PropertyTagProps {
  value?: string
}

const PropertyTag = ({ value }: PropertyTagProps) => {
  return value ? <span className={`property-tag ${value}`}>{upperFirst(lowerCase(value))}</span> : null
}

export default PropertyTag
